<template>
  <div>
  <div v-if="objectIsEmpty(conversions)">Нет выбранных конве</div>
    <b-form id="conversion_submit" @submit="onSubmit" v-if="!objectIsEmpty(conversions)">
      <div class="row">
        <div class="col-sm-12">
          <label>Оффер</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-11">
          <b-form-group>
            <v-select :options="selectOffers" :filter="filterOffers" required label="title" v-model="selectedOffer"
                      placeholder="Оффер">
              <span slot="no-options">Совпадений не найдено.</span>
              <template slot="option" slot-scope="option">
                <span>({{ option.id }}) {{ option.title }}</span>
              </template>
            </v-select>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <b-form-group label="Дата загрузки"
                        label-for="title">
            <datepicker input-class="form-control"
                        class="date"
                        :language="ru"
                        v-model="conversionsData.loading_date"
                        placeholder=""></datepicker>
          </b-form-group>
          <b-form-group label="Название платформы"
                        label-for="title">
            <b-form-input id="title"
                          type="text"
                          v-model="conversionsData.platform_name">
            </b-form-input>
          </b-form-group>
          <b-form-group label="Байер">
            <v-select label="name" :options="users"

                      required v-model="selectedUser" placeholder="Медиабайер">
              <span slot="no-options">Совпадений не найдено.</span>
            </v-select>
          </b-form-group>
          <b-form-group label="Группа источника">
            <v-select :options="sourceGroups" required label="name" v-model="selectedSourceGroup"
                      placeholder="Группа источника">
              <span slot="no-options">Совпадений не найдено.</span>
              <template slot="option" slot-scope="option">
                <span>({{ option.id }}) {{ option.name }}</span>
              </template>
            </v-select>
          </b-form-group>
          <b-button type="submit" class="float-right"
                    variant="primary">Сохранить и выйти
          </b-button>
        </div>
      </div>

      <div class="form-errors"></div>
    </b-form>
  </div>
</template>
<script>
import ConversionsService from '../../../services/conversionsDataService';
import OffersService from '../../../services/offersDataService';

import AdvertiserFormMixin from "../mixins/Advertiser/advertiserFormMixin";
import {th} from "../../../services/customLocaleDatepicker";
import Datepicker from 'vuejs-datepicker'
import {ru} from '../../../services/customLocaleDatepicker'

export default {
  name: 'MassUpdateConversionsModal',
  components: {
    ConversionsService: ConversionsService,
    OffersService: OffersService,
    Datepicker: Datepicker
  },
  mixins: [AdvertiserFormMixin],
  props: {
    conversions: {},
  },
  data() {
    return {
      currency: [],
      // options: [this.conversionsData.id],
      submitted: false,
      isMobile: false,
      window: {
        width: 0,
        height: 0
      },
      selectOffers: [],
      selectedOffer: null,
      users: [],
      selectedUser: null,
      ru: ru,
      conversionsData: {
        loading_date: null,
        offer_id: null,
        platform_name: null,
        buyer_id: null,
        source_group_id: null
      },
      sourceGroups: [],
      selectedSourceGroup: null
    }
  },
  methods: {
    onSubmit(evt) {
      // evt.preventDefault();
      this.submitted = true;
      let conversionsData = {}

      conversionsData.offer_id = this.selectedOffer ? this.selectedOffer.id : null
      conversionsData.buyer_id = this.selectedUser ? this.selectedUser.network_partner_id : null
      conversionsData.loading_date = this.conversionsData.loading_date ? this.conversionsData.loading_date : null
      conversionsData.platform_name = this.conversionsData.platform_name ? this.conversionsData.platform_name : null
      conversionsData.sourceGroup = this.selectedSourceGroup ? this.selectedSourceGroup.id : null

        let conversionsArray = []

        Object.keys(this.conversions).forEach(function(key){
            if (this.conversions[key]) {
                conversionsArray.push(key)
            }
        }.bind(this))

      conversionsData.ids = conversionsArray

      ConversionsService.updateConversions(conversionsData)
        .then(response => {
          if (response) {
            toastr.success('Ok')
          } else {
            toastr.error('Ошибка.')
          }
        })
        .catch(err => {
          toastr.error('Ошибка.')

        })
    },
    getOffersForSelect() {
      let sort = {
        sortBy: 'created_at',
        sortDesc: true,
      }

      let range = {
        startDate: null,
        endDate: null
      }
      let user = null;

      OffersService.getOffers(1, sort, null, range, user, true)
        .then(function (response) {
          this.selectOffers = response;
        }.bind(this))
    },
    getGroups() {
      ConversionsService.getSourceGroups()
        .then(function (groups) {
          this.sourceGroups = groups
        }.bind(this))
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      if (this.window.width < 577) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },

    getCurrency() {
      OffersService.getCurrency()
        .then(function (response) {

          this.currency = response;
        }.bind(this))
    },
    objectIsEmpty(obj) {
      return Object.values(obj).every(value => {
        return value === null || value === false;
      });
    },
    filterOffers(options, search) {
      if (search) {
        return options.filter(option => {
          return option.title.toLowerCase().indexOf(search.toLowerCase()) >= 0 || option.id.toString().indexOf(search.toString()) >= 0;
        });
      }
    },
    getUsersWithPartnerNetworkId() {
      OffersService.getUsers()
        .then(users => {
          this.users = users
        })
    },
  },


  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  beforeMount() {
    this.getCurrency();
    this.getOffersForSelect()
    this.getUsersWithPartnerNetworkId()
    this.getGroups()
  },
}
</script>



// WEBPACK FOOTER //
// resources/js/views/front/modals/MassUpdateConversionsModal.vue